import React from 'react';
import { VENUE_TYPES } from '../../constants/venueData';
import './InteractiveCarousel.css';

const InteractiveCarousel = () => {
  return (
    <div className="interactive-carousel-container">
      <div className="carousel-header">
        Whatever THE Event, WE a Venue for YOU
      </div>
      
      {/* First marquee - Left to Right */}
      <div className="marquee marquee-1">
        <div className="marquee__content">
          {/* Create multiple copies for seamless infinite scroll */}
          {Array.from({ length: 3 }, (_, copyIndex) => 
            VENUE_TYPES.map((type, index) => (
              <span key={`first-${copyIndex}-${index}`} className="marquee__item">
                {type}
                <span className="separator"> • </span>
              </span>
            ))
          )}
        </div>
      </div>

      {/* Second marquee - Right to Left (Reverse) */}
      <div className="marquee marquee-2">
        <div className="marquee__content marquee__content--reverse">
          {/* Create multiple copies for seamless infinite scroll */}
          {Array.from({ length: 3 }, (_, copyIndex) => 
            VENUE_TYPES.map((type, index) => (
              <span key={`second-${copyIndex}-${index}`} className="marquee__item">
                {type}
                <span className="separator"> • </span>
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default InteractiveCarousel; 